import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "../styles/whatsapp-widget.css";

const WHATSAPP_URL = "https://wa.me/+918838887194";

export const WhatsAppWidget = () => (
    <a
        className="whatsapp-widget"
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
    >
        <span className="whatsapp-widget__pulse" aria-hidden="true" />
        <span className="whatsapp-widget__icon" aria-hidden="true">
            <FaWhatsapp />
        </span>
        <span className="whatsapp-widget__label">Chat with us</span>
    </a>
);
